import { AuthPanelCode, AuthPanelEmail, AuthPanelPassword, AuthPanelProfile } from '@/features/auth'
import type {
  AuthPanelCodeProps,
  AuthPanelEmailProps,
  AuthPanelPasswordProps,
  AuthPanelProfileProps,
} from '@/features/auth'

export type AuthLayoutPanel = 'email' | 'code' | 'password' | 'profile'

type BaseLayoutProps = {
  panel: AuthLayoutPanel
  className?: string
}

type EmailPanelProps = {
  panel: 'email'
  panelProps?: Omit<AuthPanelEmailProps, 'variant' | 'className'>
  variant?: AuthPanelEmailProps['variant']
}

type CodePanelProps = {
  panel: 'code'
  panelProps: Omit<AuthPanelCodeProps, 'variant' | 'className'>
  variant?: AuthPanelCodeProps['variant']
}

type PasswordPanelProps = {
  panel: 'password'
  panelProps?: Omit<AuthPanelPasswordProps, 'variant' | 'className'>
  variant?: AuthPanelPasswordProps['variant']
}

type ProfilePanelProps = {
  panel: 'profile'
  panelProps?: Omit<AuthPanelProfileProps, 'variant' | 'className'>
  variant?: AuthPanelProfileProps['variant']
}

export type AuthLayoutProps = BaseLayoutProps &
  (EmailPanelProps | CodePanelProps | PasswordPanelProps | ProfilePanelProps)

export function AuthLayout(props: AuthLayoutProps) {
  const { className } = props

  switch (props.panel) {
    case 'email':
      return <AuthPanelEmail {...props.panelProps} className={className} variant={props.variant} />
    case 'code':
      return <AuthPanelCode {...props.panelProps} className={className} variant={props.variant} />
    case 'password':
      return (
        <AuthPanelPassword {...props.panelProps} className={className} variant={props.variant} />
      )
    case 'profile':
      return (
        <AuthPanelProfile {...props.panelProps} className={className} variant={props.variant} />
      )
    default:
      return null
  }
}
